/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react'
import AdvancedSearchInputBox from '../../../../components/AdvancedSearchInput/AdvancedSearchInputBox';
import DateInput from '../../../../components/DateField';
import { useSelector,useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import GlobalContext from '../../../../components/Context/GloablContext';
import Dropdown from '../../../../components/Dropdown';
import { resetAccessLogSearch,setAccessLogSearch } from '../../../../redux/accessLogSearchSlice';

export default function AccessLogSearch({handleOnSubmit,emptyField,setEmptyField,providerAlertsSearch,monitorConditionTemplateSearch}) {
    const accessLogSearch = useSelector(state => state.accessLogSearchData);
    const {isAdvancedSearchOpen,setIsAdvancedSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);
    const [searchParams,setSearchParams]=useSearchParams()
    const dispatch = useDispatch()

    const sidebarPrvState = useSelector(state => state?.systemConfigData?.sidebarPrvState)
    const searchApplied = useSelector((state) => state.accessLogSearchData.accessLogSearchApplied);

    const accessLogActions = ['Login','Logout','Session Timeout','Password Fail','Username Fail','OTP Mistype','Login Duplicate','Logout Duplicate','OTP Selection','Login Timeout','Attempts Exceeded','Resend OTP','Forgot Password',]
    
    // handleOnChangeUserDetails function
    const handleOnChangeUserDetails = (id, value) => {
        let updatedValue = value;
        // Allow only numeric input for the "age" field
        if (id === 'age' ) {
        // Use a regular expression to allow only numbers
            updatedValue = updatedValue.replace(/\D/g, ''); // Removes any non-numeric characters
        }

        if (typeof updatedValue === 'string') {
            updatedValue = updatedValue;
        }
    
        const updatedState = { ...accessLogSearch, [id]: updatedValue };
    
        if (updatedValue === '' && updatedState[`${id}_inverse`] === 'true') {
            updatedState[`${id}_inverse`] = '';
        }
    
        // Update the patientSearch state and dispatch to Redux
        setAccessLogSearch(updatedState);
        dispatch(setAccessLogSearch(updatedState));
    };

    //handleSelect checkbox functions
    const handleCheckboxChange = (e, field) => {
        const { checked } = e.target;
    
        // Create an updated patientSearch state
        let updatedState = { ...accessLogSearch };
    
        if (field === 'High' || field === 'Medium') {
            // Update the status array if it's a status-related checkbox
            const updatedalert_severity = checked 
                ? [...(accessLogSearch.alert_severity || []), field] 
                : (accessLogSearch.alert_severity || []).filter((alert_severity) => alert_severity !== field);
    
            // Uncheck alert_severity_inverse if the alert_severity array is empty
            if (updatedalert_severity.length === 0) {
                updatedState.alert_severity_inverse = '';
            }
    
            updatedState.alert_severity = updatedalert_severity;
        } else {
            // Handle other fields as boolean values
            updatedState[field] = checked ? 'true' : '';
        }
    
        // Dispatch the updated state
        dispatch(setAccessLogSearch(updatedState));
    };
        
    // Function to handle button click
    const handleCloseClick = () => {
    // Toggle the advanced search state
        setIsAdvancedSearchOpen(!isAdvancedSearchOpen)  
        // If previous sidebar state was true and isSideBar is currently false, set it to true
        if (sidebarPrvState === true && !isSideBar) {
            setIsSideBar(true);
        }
        // Reset search state if searchApplied is false
        if (!searchApplied) {            
            dispatch(resetAccessLogSearch());
        }
    };

    const isApplyButtonDisabled = () => {
        return Object.entries(accessLogSearch).every(([key, value]) => {
            if (key === 'match') return true; // Ignore 'match'
    
            // Check if value is an array
            if (Array.isArray(value)) {
                return value.length === 0; // Return true if the array is empty
            }
    
            // Check if value is a string
            if (typeof value === 'string') {
                return value.trim() === ''; // Trim and check if it's empty
            }
    
            // For any other type (objects, numbers, etc.), return true to indicate it's 'empty'
            return true;
        });
    };

    /*** The `handleClearAll` function resets parameters and clears search-related fields.*/
    const handleClearAll = () => {
        dispatch(resetAccessLogSearch());
        const updatedParams = new URLSearchParams(searchParams);
        updatedParams.delete('search');
        updatedParams.delete('search_mode');
        setTimeout(()=>{
            setSearchParams(Object.fromEntries(updatedParams.entries()));
            setEmptyField(false);
        },300)

    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                handleClearAll();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    useEffect(() => {
        const params = Object.fromEntries(searchParams);
        if (params.search) {
            const searchDecoded = decodeURIComponent(params.search);
    
            // Helper function to extract matches and handle multiple values
            const extractValues = (fieldName) => {
                const match = searchDecoded.match(new RegExp(`${fieldName}=(ne:)?([^;]+(?:;[^;]*)*)(;|$)`));
                if (match) {
                    const isInverse = !!match[1];
                    const rawValues = match[2];
                    const values = rawValues.split(';').map((value) => value.trim());
                    return { isInverse, values };
                }
                return null;
            };
    
            // Temporary state object
            const updatedState = {};
    
            // Extract and populate fields
            const userIdData = extractValues('user_id');
            if (userIdData) {
                updatedState.user_id = userIdData.values.includes('__NULL__') ? '-' : userIdData.values.join('; ');
                updatedState.user_id_inverse = userIdData.isInverse ? 'true' : '';
            }
    
            const timezoneData = extractValues('timezone');
            if (timezoneData) {
                updatedState.timezone = timezoneData.values.includes('__NULL__') ? '-' : timezoneData.values.join('; ');
                updatedState.timezone_inverse = timezoneData.isInverse ? 'true' : '';
            }
    
            const actionData = extractValues('action');
            if (actionData) {
                updatedState.action = actionData.values.includes('__NULL__') ? '-' : actionData.values.join('; ');
                updatedState.action_inverse = actionData.isInverse ? 'true' : '';
            }
    
            const ipAddressData = extractValues('ip_address');
            if (ipAddressData) {
                updatedState.ip_address = ipAddressData.values.includes('__NULL__') ? '-' : ipAddressData.values.join('; ');
                updatedState.ip_address_inverse = ipAddressData.isInverse ? 'true' : '';
            }
    
            const deviceInfoData = extractValues('device_information');
            if (deviceInfoData) {
                updatedState.device_information = deviceInfoData.values.includes('__NULL__') ? '-' : deviceInfoData.values.join('; ');
                updatedState.device_information_inverse = deviceInfoData.isInverse ? 'true' : '';
            }
    
            const valueData = extractValues('value');
            if (valueData) {
                updatedState.value = valueData.values.includes('__NULL__') ? '-' : valueData.values.join('; ');
                updatedState.value_inverse = valueData.isInverse ? 'true' : '';
            }
    
            // Handle search_mode
            if (params.search_mode) {
                updatedState.match = params.search_mode === 'or';
            }
    
            // Dispatch the action with the updated state
            dispatch(setAccessLogSearch(updatedState));
        }
    }, [isAdvancedSearchOpen]);
    
    
    
    

    return (
        <div className='absolute top-0 left-0 w-[267px] rounded-tr-[12px] rounded-br-[12px] shadow-s7 h-[100dvh] bg-[#ffffff] z-[100]'>
            <form action='' 
                onSubmit={(e) => {handleOnSubmit(e);}} // Existing submit handler
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {                        
                        e.preventDefault(); 
                        handleOnSubmit(e);
                    }
                }}
                className='w-full px-3 py-4'>
                <section className='flex justify-between items-center'>
                    <p className='text-sm font-semibold text-[#52555D]'>Advanced Search</p>
                    <button type='button' onClick={handleCloseClick}>
                        <img src="/images/cross_mark_gray.svg" alt="close-icon" loading='lazy' decoding='async' />
                    </button>
                </section>
                <section className='mt-4 flex items-center pb-4 border-b border-[#C5C9DA]'>
                    <p className='text-xs font-normal text-[#000000] pr-2'>Match:</p>
                    <div className='flex items-center'>
                        <div className='flex items-center'>
                            <div className="relative custom-radioBlue flex items-center">
                                <input id="match_any" type="radio" name="default-radio1" checked={accessLogSearch?.match} onChange={()=>handleOnChangeUserDetails("match",true)}/>
                                <label htmlFor="match_any" className={`text-xs font-normal ${accessLogSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    Any
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px] mt-[1px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match any of the input values. <br />
                                    Example: A OR B will return results that match either A, B, or both.
                                </p>
                            </div>
                        </div>
                        <div className='flex items-center ml-4'>
                            <div className="relative custom-radioBlue flex items-center ml-3" >
                                <input id="match_all"  type="radio" name="default-radio1" checked={!accessLogSearch?.match} onChange={()=>handleOnChangeUserDetails("match",false)}/>
                                <label htmlFor="match_all" className={`text-xs font-normal ${!accessLogSearch?.match ? 'text-[#000000]' : 'text-[#52555D]'} pl-6 pr-2 w-full cursor-pointer`}>
                                    All 
                                </label>
                            </div>
                            <div className='relative'>
                                <span className='any_hover'>
                                    <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px] mt-[1px]' />
                                </span>
                                <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[1]'>
                                    Displays results that match all of the input values. <br />
                                    Example: A AND B will only return results that match both A and B.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {emptyField && 
                    <p className='text-xs font-normal text-[#c52828] my-1 text-center'>Please fill the date field completely</p>
                }
                <div className='w-full flex items-center my-3'>
                    <div className='w-[170px] mr-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Column Name & Value</p>
                    </div>
                    <div className='relative w-[65px] flex items-center'>
                        <p className='text-xs font-normal text-[#52555D]'>Inverse</p>
                        <span className='any_hover z-[99] ml-1'>
                            <img src="/images/Tooltip.svg" alt="icon" loading='lazy' decoding='async' className='w-[15px] h-[15px]' />
                        </span>
                        <p className='bg-[#000000] bg-opacity-75 p-2 text-xs font-normal text-[#FFFFFF] transition-all absolute top-[25px] left-[0px] any_hover_text hidden rounded-lg w-[212px] z-[10]'>
                            Excludes results that match the input value. <br />
                            Example: NOT A will return all results except those that match A.
                        </p>
                    </div>
                </div>
                <div className='-ml-2'>
                    <div className={`overflow-auto ${emptyField?'h-[calc(100dvh-302px)]':'h-[calc(100dvh-285px)]'} scrollbar_purple pl-2`}>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={`ID`}
                                    placeholder={`Enter ID`}
                                    id={"user_id"}
                                    data_testid={"user_id"}
                                    htmlFor={"user_id"}
                                    value={accessLogSearch.user_id}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={`16`}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='user_id_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'user_id_inverse')}
                                        checked={accessLogSearch.user_id_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={accessLogSearch?.user_id?.trim()===""}
                                    />
                                    <label htmlFor='user_id_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Timezone"}
                                    placeholder={"Enter timezone"}
                                    id={"timezone"}
                                    data_testid={"timezone"}
                                    htmlFor={"timezone"}
                                    value={accessLogSearch?.timezone}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='timezone_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'timezone_inverse')}
                                        checked={accessLogSearch?.timezone_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={accessLogSearch?.timezone?.trim()===""}
                                    />
                                    <label htmlFor='timezone_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <Dropdown
                                    label={"Action"}
                                    id={"action"}
                                    placeholder={accessLogSearch?.action?.length > 0 ? '' : 'Select action'}
                                    data_testid={"action"}
                                    value={accessLogSearch?.action}
                                    options={accessLogActions}
                                    handleOnChangeInput={handleOnChangeUserDetails}   
                                    searchDropdown={true}  
                                />     
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='action_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'action_inverse')}
                                        checked={accessLogSearch?.action_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={accessLogSearch?.action.trim()===''}
                                    />
                                    <label htmlFor='action_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>        
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"IP Address"}
                                    placeholder={"Enter IP Address"}
                                    id={"ip_address"}
                                    data_testid={"ip_address"}
                                    htmlFor={"ip_address"}
                                    value={accessLogSearch?.ip_address}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='ip_address_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'ip_address_inverse')}
                                        checked={accessLogSearch?.ip_address_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={accessLogSearch?.ip_address?.trim()===""}
                                    />
                                    <label htmlFor='ip_address_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Device"}
                                    placeholder={"Enter device"}
                                    id={"device_information"}
                                    data_testid={"device_information"}
                                    htmlFor={"device_information"}
                                    value={accessLogSearch?.device_information}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={500}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='device_information_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'device_information_inverse')}
                                        checked={accessLogSearch?.device_information_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={accessLogSearch?.device_information?.trim()===""}
                                    />
                                    <label htmlFor='device_information_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>   
                        <div className='w-full flex border-b border-[#C5C9DA66] pb-2 pt-1'>
                            <div className='w-[170px] mr-2'>
                                <AdvancedSearchInputBox
                                    label={"Value"}
                                    placeholder={"Enter value"}
                                    id={"value"}
                                    data_testid={"value"}
                                    htmlFor={"value"}
                                    value={accessLogSearch?.value}
                                    handleOnChangeInput={handleOnChangeUserDetails}
                                    maxLength={60}
                                />
                            </div>
                            <div className='relative w-[65px] mt-[20px]'>
                                <div className='p-[8px] flex items-center mark-check mark-check1 relative checkbox custom-checkBoxBlue1'>
                                    <input
                                        type='checkbox'
                                        id='value_inverse'
                                        onChange={(e) => handleCheckboxChange(e, 'value_inverse')}
                                        checked={accessLogSearch?.value_inverse === 'true'}
                                        className='h-[18px] w-[18px] cursor-pointer z-[11] disabled:cursor-not-allowed'
                                        disabled={accessLogSearch?.value?.trim()===""}
                                    />
                                    <label htmlFor='value_inverse' className='text-[16px] font-normal text-[#000] ml-[16px] cursor-pointer'>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='border-t border-[#C5C9DA]'>
                    <section className='mt-2'>
                        <p className='text-xs font-normal text-[#52555D]'>Note:</p>
                        <ol className='list-decimal pl-4 text-xs font-normal text-[#52555D]'>
                            <li>Use a dash (-) to indicate a null value.</li>
                            <li>Use an asterisk (*) as a wild-card character.</li>
                        </ol>
                    </section>
                </div>
                <div className="flex mt-[13px] justify-between">
                    <button 
                        id="Cancel"
                        type='button'
                        onClick={() => handleClearAll()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault(); // Prevent form submission
                                handleClearAll(); // Perform the clear action
                            }
                        }}

                        className="py-2.5 px-4 rounded-[16px] border border-[#972E4C] text-sm font-semibold text-[#972E4C] min-w-fit focus:bg-[#edc9d3]" 
                    >Clear All</button>
                    <button  
                        type='submit'
                        id="apply-filter"
                        disabled={isApplyButtonDisabled()}
                        className={`py-2.5 w-[106px] px-4 rounded-[16px]  disabled:bg-[#777C88] bg-[#972E4C] hover:bg-[#AB556E] border border-[#972E4C]'} text-sm font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}>
                        Apply
                    </button>
                </div>
            </form>
        </div>
    )
}
